const clockFormat = new Intl.DateTimeFormat('tr-TR', { hour: '2-digit', minute: '2-digit' });
const dayFormat = new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
const fullFormat = new Intl.DateTimeFormat('tr-TR', { dateStyle: 'long', timeStyle: 'short' });
const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
/** "10:42" */
export const clock = (iso) => clockFormat.format(new Date(iso));
/** "2 Kasım 2026 10:42", for tooltips. */
export const fullDate = (iso) => fullFormat.format(new Date(iso));
export const sameDay = (a, b) => startOfDay(new Date(a)) === startOfDay(new Date(b));
/** "Bugün", "Dün" or "2 Kasım 2026". */
export function dayLabel(iso, now = new Date()) {
    const days = Math.round((startOfDay(now) - startOfDay(new Date(iso))) / 86_400_000);
    if (days === 0)
        return 'Bugün';
    if (days === 1)
        return 'Dün';
    return dayFormat.format(new Date(iso));
}
//# sourceMappingURL=time.js.map